$(document).ready(function() {
  
  console.log("DOM fully loaded and parsed");

  $(document).on('click', '.btn.add-to-cart-button.bundling', function(event) {
    event.preventDefault();
    console.log("Add to Cart button clicked");

    var itemsToAdd = $('#productModal .variant-select').map(function() {
      return {
        id: $(this).val(),
        quantity: 1
      };
    }).get();

    $.ajax({
      url: '/cart/add.js',
      method: 'POST',
      dataType: 'json',
      contentType: 'application/json',
      data: JSON.stringify({ items: itemsToAdd }),
      success: function(data) {
        console.log('Items added to cart:', data);
        $(document.documentElement).trigger("theme:cartchanged");
        $(".cart-link").click();
        $('#productModal').hide();
        // alert('Items successfully added to cart');
      },
      error: function(xhr, status, error) {
        console.error('Error adding items to cart:', error);
        //alert('There was an error adding the items to the cart. Please try again.');
      }
    });
  });

  console.log("Event delegation setup completed");

   // $('.image-cont .rimage-wrapper').hover(function() {
   //    console.log('hoverr');
   //                  $(this).find('.mobile_swatch .collection_swatches_outer').css('opacity', '1');
   //              },
   //              function() {
   //                  $(this).find('.mobile_swatch .collection_swatches_outer').css('opacity', '0');
   //              }
   //          );
  
});


$(document).ready(function() {
  // Select all product blocks
  $('.product-block').each(function() {
    var $productBlock = $(this);
    var $imageCont = $productBlock.find('.image-cont');
    var $mobileSwatch = $productBlock.find('.mobile_swatch');

    if ($imageCont.length && $mobileSwatch.length) {
      $imageCont.hover(
        function() {
          // $mobileSwatch.css('opacity', '1');
          $mobileSwatch.addClass('visible');
        },
        function() {
          if (!$mobileSwatch.is(':hover')) {
             $mobileSwatch.removeClass('visible');
           }
          // $mobileSwatch.css('opacity', '0'); // Optional: Remove this line if you don't want to add the class back on mouseout.
        }
      );
        $mobileSwatch.hover(
                        function() {
                            $mobileSwatch.addClass('visible');
                        },
                        function() {
                            $mobileSwatch.removeClass('visible');
                        }
                    );
    }
  });
});




